import { render, staticRenderFns } from "./InstalledListCallback.vue?vue&type=template&id=2853ab93&scoped=true"
import script from "./InstalledListCallback.vue?vue&type=script&lang=js"
export * from "./InstalledListCallback.vue?vue&type=script&lang=js"
import style0 from "./InstalledListCallback.vue?vue&type=style&index=0&id=2853ab93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2853ab93",
  null
  
)

export default component.exports